import { useState } from "react";
import { toast } from "sonner";
import { Save, KeyRound, Lock } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Block } from "./Common";

function MemberCard({ m, jobFunctions, onChanged }) {
  const [f, setF] = useState({ name: m.name, role: m.role, email: m.email, phone: m.phone || "" });
  const [pin, setPin] = useState("");
  const call = async (fn, ok) => {
    try {
      await fn();
      toast.success(ok);
      onChanged();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const save = () => call(() => api.put(`/members/${m.id}`, f), "Data anggota tersimpan");
  const toggle = (k, ok) => call(() => api.post(`/members/${m.id}/${k}`), ok);
  const reset = () => call(async () => { await api.post(`/members/${m.id}/reset-pin`, { pin }); setPin(""); }, `PIN ${m.name} direset`);
  return (
    <div data-testid={`member-card-${m.id}`} className={`rounded-2xl border p-4 ${m.active ? "border-brand-line" : "border-dashed border-brand-line bg-[#faf7f7] opacity-80"}`}>
      <div className="mb-3 flex flex-wrap items-center gap-2 text-xs">
        <span className="rounded-full bg-brand-tint px-2.5 py-1 font-bold text-brand-deep">{m.tier === "anggota" ? "Anggota" : m.tier === "leader" ? "Leader" : "Manager"}</span>
        <span className={`rounded-full px-2.5 py-1 font-bold ${m.mustReport ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-600"}`}>{m.mustReport ? "Wajib lapor" : "Pantau saja"}</span>
        {!m.active && <span className="rounded-full bg-slate-200 px-2.5 py-1 font-bold">Nonaktif</span>}
        {m.locked && <span className="inline-flex items-center gap-1 rounded-full bg-brand px-2.5 py-1 font-bold text-white"><Lock size={11} /> Terkunci</span>}
      </div>
      <div className="grid gap-2 sm:grid-cols-2">
        <input data-testid={`member-name-${m.id}`} className="field" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
        <select data-testid={`member-role-${m.id}`} className="field" value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })}>
          {jobFunctions.map((j) => <option key={j.name} value={j.name}>{j.name}</option>)}
        </select>
        <input data-testid={`member-email-${m.id}`} className="field" type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
        <input data-testid={`member-phone-${m.id}`} className="field" inputMode="tel" placeholder="No WhatsApp (opsional)" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} />
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        <button data-testid={`member-save-${m.id}`} onClick={save} className="btn-primary"><Save size={15} /> Simpan</button>
        <button data-testid={`member-toggle-must-${m.id}`} onClick={() => toggle("toggle-must-report", "Status lapor diubah")} className="btn-ghost">
          {m.mustReport ? "Jadikan Pantau saja" : "Jadikan Wajib lapor"}
        </button>
        <button data-testid={`member-toggle-active-${m.id}`} onClick={() => toggle("toggle-active", m.active ? "Anggota dinonaktifkan" : "Anggota diaktifkan")} className="btn-ghost">
          {m.active ? "Nonaktifkan" : "Aktifkan"}
        </button>
        <div className="flex flex-1 gap-2">
          <input data-testid={`member-pin-${m.id}`} className="field min-w-[90px] flex-1" type="password" inputMode="numeric" maxLength={6} placeholder="PIN baru"
            value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))} />
          <button data-testid={`member-reset-pin-${m.id}`} onClick={reset} className="btn-soft shrink-0"><KeyRound size={15} /> Reset PIN</button>
        </div>
      </div>
    </div>
  );
}

export default function PanelMembers({ members, jobFunctions, onChanged }) {
  return (
    <Block title={`Anggota (${members.length})`} testid="panel-members">
      <div className="grid gap-3 xl:grid-cols-2">
        {members.map((m) => (
          <MemberCard key={`${m.id}-${m.name}-${m.role}-${m.email}-${m.phone}`} m={m} jobFunctions={jobFunctions} onChanged={onChanged} />
        ))}
        {members.length === 0 && <p className="text-sm text-[#7a6667]">Belum ada anggota.</p>}
      </div>
    </Block>
  );
}
